import React from "react";
import './student-name-list.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";
import CommonUtils from "../../../../utility/common-utilities";

class StudentNameList extends React.Component {

    state = {
        clickerSetDropdown: [],
        clickerUserList: [],
        showStudentClickerList: false,
        setName: "",
        studentList: []
    }


    constructor(props) {
        super(props)

    }

    componentDidMount() {
        let studentList = this.props.selectedItem.users

        if (studentList.length) {
            studentList = studentList.sort((a, b) => Number(a.rollNumber) - Number(b.rollNumber));
            const middle = Math.ceil(studentList.length / 3);

            const firstHalf = studentList.slice(0, middle);
            const secondHalf = studentList.slice(middle, middle * 2);
            const thirdHalf = studentList.slice(middle * 2);

            this.setState({ studentList: firstHalf, secondHalf, thirdHalf })
        }

    }



    onClickBack() {
        this.props.delegate && this.props.delegate.onHideUserList && this.props.delegate.onHideUserList()
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props?.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props?.selectedItem?.section || ""} >`}</span>
                {
                    this.props.selectedItem.type === 'CLICKER_ASSESSMENT' ?
                        <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`}</span>
                        :
                        <span className='pl-2'>{`${this.props?.selectedItem?.chapter} >`}</span>
                }

                {
                    CommonUtils.isOnline() ?
                    <span className='pl-2'>{this.getDate(this.props?.selectedItem?.createdDateTimestamp)}</span>
                    :
                    <span className='pl-2'>{this.props?.selectedItem?.createdDateTimestamp ? this.props?.selectedItem?.createdDateTimestamp : this.props?.selectedItem.createdDate ? this.props?.selectedItem.createdDate : '' }</span>
                }

                
            </div>
        )
    }

    hideStudentClickerList() {
        this.setState({ showStudentClickerList: false, clickerUserList: [] })
    }



    //  if (item?.users?.length) {
    //             item.users = item?.users.sort((a, b) => Number(a.rollNumber) - Number(b.rollNumber));
    //         }


    render() {
        return (
            <div className="student-name-list-v3">
                <div className='mb-3 item1'>
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>

                <div className='d-flex align-items-center justify-content-between header-report-card mb-1'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.RECOMMENDATION_REPORT_CIRCLE)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1'>Student Name List</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-4">
                        <div id="table-scoll" className="table-responsive mt-1">
                            <table className="table cw-table">
                                <thead>
                                    <tr>
                                        <th className="th-left-radius" width = '80%'>Name</th>
                                        <th className="th-right-radius" width = '20%'>#.</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        this.state.studentList && this.state.studentList.length ? this.state.studentList.map((item, index) => (

                                            <tr >
                                                <td className="">
                                                    {item.name}
                                                </td>
                                                <td className=''>{item.rollNumber ? item.rollNumber : ''}</td>
                                            </tr>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div >
                    </div>
                    <div className="col-4">
                        <div id="table-scoll" className="table-responsive mt-1">
                            <table className="table cw-table">
                                <thead>
                                    <tr>
                                        <th className="th-left-radius" width = '80%'>Name</th>
                                        <th className="th-right-radius" width = '20%'>#.</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        this.state.secondHalf && this.state.secondHalf.length ? this.state.secondHalf.map((item, index) => (
                                            <tr >
                                                <td className="">
                                                    {item.name}
                                                </td>
                                                <td className=''>{item.rollNumber ? item.rollNumber : ''}</td>
                                            </tr>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div >
                    </div>
                    <div className="col-4">
                        <div id="table-scoll" className="table-responsive mt-1">
                            <table className="table cw-table">
                                <thead>
                                    <tr>
                                       <th className="th-left-radius" width = '80%'>Name</th>
                                        <th className="th-right-radius" width = '20%'>#.</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        this.state.thirdHalf && this.state.thirdHalf.length ? this.state.thirdHalf.map((item, index) => (
                                            <tr >
                                                <td className="">
                                                    {item.name}
                                                </td>
                                                <td className=''>{item.rollNumber ? item.rollNumber : ''}</td>
                                            </tr>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div >
                    </div>
                </div>


            </div>
        )
    }

}

export default StudentNameList;